import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Dining = () => {
  const { t } = useLanguage();

  return (
    <section 
      id="dining" 
      className="py-10 md:py-12 bg-white" 
      data-testid="dining-section"
    >
      <div className="container mx-auto px-6 md:px-12 max-w-[1400px]">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-black mb-6">
            {t('dining.title')}
          </h2>
          <p className="text-lg md:text-xl text-black/70 max-w-3xl mx-auto font-light text-center">
            {t('dining.description')}
          </p>
          <p className="text-xs md:text-sm text-black/60 max-w-3xl mx-auto font-light text-center mt-6 uppercase tracking-widest">
            RESPIRO BEACH BAR AND RESTAURANT OPENING SPRING 2027
          </p>
        </div>
      </div>

      {/* Full-width Ribbon Image */}
      <div className="w-full">
        <img 
          src="https://customer-assets.emergentagent.com/job_respiro-retreat/artifacts/71gqxgdy_Barefoot1416.jpg"
          alt={t('dining.title')}
          loading="lazy"
          className="w-full h-[300px] md:h-[400px] lg:h-[500px] object-cover"
        />
      </div>
    </section>
  );
};

export default Dining;
